import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useLogModel } from "../logModel";

export function Log() {
    const {
        loadData,
        resetState,
    } = useLogModel()
    useEffect(() => {
        loadData({ pageNum: 1 }).then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

